import { AssignmentIndOutlined } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsRefFragebogenProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsRefFragebogenComponent = ({ veranstaltung }: VeranstaltungsRefFragebogenProps) => (
  <CustomAccordion title="Referenten-Fragebogen" icon={AssignmentIndOutlined} open={false}>
    <Grid container spacing={1} rowSpacing={-5}>
      <Grid size={5}>Seminarunterlagen:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.referentenfragebogenseminarunterlage}</b>
      </Grid>
      <Grid size={5}>Raum:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.referentenfragebogenraum}</b>
      </Grid>
      <Grid size={5}>Hotel:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.referentenfragebogenhotel}</b>
      </Grid>
      <Grid size={5}>Anreise:</Grid>
      <Grid size={7}>
        <b>{veranstaltung.referentenfragebogenanreise}</b>
      </Grid>
    </Grid>
  </CustomAccordion>
);
